<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="card"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="所属学员" prop="student_id">
        <v-select-student
          class="w100"
          v-model="card.student_id"
          :list="studentList"
          :is-get-is-used-card-invalid="true"
          @change="handleStudentChange"
        />
        <router-link v-if="card.student_id" :to="RouteConfig.studentDetail.to(card.student_id)" class="primary-color">
          查看学员主页
        </router-link>
      </el-form-item>

      <el-form-item v-if="cardNumber" label="可用积分">
        <span class="integral-box">
          <b class="primary-color integral">{{ integral | toYuan }}</b> 分
        </span>
      </el-form-item>
      <v-input-card-number v-else v-model="card.card_number" :exclude-student-id="card.student_id"/>

      <el-form-item v-if="integral" label="使用积分" prop="payment_remark">
        <v-input-money
          placeholder="请输入购买课卡所用的积分"
          v-model="card.integral"
          :is-show-suffix="true"
          suffix-name="分"
          :min="0"
          :max="integral | toYuan"
        />
      </el-form-item>

      <el-form-item label="适用门店">
        <v-select-store
          class="w100"
          v-model="card.store_ids"
          :multiple="true"
          :is-location-limit="true"
          placeholder="全国通用"
        />
      </el-form-item>

      <el-form-item label="课卡类型" prop="card_charge_type_id">
        <v-cascader-card-type
          v-model="cardTypeInfo"
          :store-ids="card.store_ids"
          :is-new="isNew"
          :student-id="card.student_id"
          @change="handleCardTypeChange"
        />
      </el-form-item>

      <template v-if="cardTypeInfo.length">
        <el-form-item label="禁止预约专栏">
          <span v-if="card.is_disable_column" class="danger-color">是</span>
          <span v-else class="success-color">否</span>
        </el-form-item>

        <el-form-item label="有效次数" prop="expire_number">
          <v-input-money
            v-if="card.is_number_limit"
            class="w100"
            placeholder="每次约课将根据课程设置的扣卡次数，扣除相应次数"
            :is-show-suffix="true"
            suffix-name="次"
            :min="0"
            :max="300"
            v-model="card.expire_number"
          />
          <span v-else class="success-color">期限卡，无次数限制</span>
          <el-alert
            v-if="isNumberDiff"
            :title="`当前输入次数与默认有效次数「 ${card.expire_number_default} 次 」不一致`"
            type="warning"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item label="有效天数" prop="expire_days">
          <v-input-number
            class="w100"
            placeholder="开卡后系统将根据有效天数自动计算出失效日期"
            :is-show-suffix="true"
            suffix-name="天"
            :min="0"
            :max="1098"
            v-model="card.expire_days"
          />
          <el-alert
            v-if="isDaysDiff"
            :title="`当前输入天数与默认有效天数「 ${card.expire_days_default} 天 」不一致`"
            type="warning"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item
          v-show="card.store_ids.length"
          label="适用门店限制天数"
          prop="store_limit_expire_days"
        >
          <v-input-number
            class="w100"
            placeholder="超过设定的天数后，课卡将自动变为全国通用"
            type="unsignedSmallInt"
            v-model="card.store_limit_expire_days"
          />
        </el-form-item>
      </template>

      <el-form-item label="代金券抵扣">
        <v-select-voucher
          class="w100"
          v-model="card.voucher_ids"
          :student-id="card.student_id"
          :card-charge-type-id="card.card_charge_type_id"
          :store-id="card.store_ids && card.store_ids.length ? card.store_ids[0] : 0"
          :multiple="true"
          :max-count="5"
          placeholder="请选择代金券（可选，可叠加）"
          :clearable="true"
          @change="handleVoucherChange"
        >
        </v-select-voucher>
        <div v-if="card.voucher_ids && card.voucher_ids.length" class="voucher-summary info-color">
          已选 {{ card.voucher_ids.length }} 张，合计抵扣
          <span class="success-color">{{ card.voucher_amount_in_cents }}</span> 元
        </div>
      </el-form-item>

      <el-form-item label="实际收款">
        <v-input-money
          class="w100"
          v-model="card.actual_payment"
          placeholder="请输入购卡实际收款（去除优惠金额）"
          :is-show-suffix="true"
        />
        <el-alert
          v-if="isPriceDiff"
          :title="priceAlertMessage"
          type="warning"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <template v-if="card.actual_payment > 0">
        <el-form-item label="收款方式" prop="card_payment_mode_id">
          <v-select-card-payment-mode class="w100" v-model="card.card_payment_mode_id"/>
        </el-form-item>

        <v-image-upload
          v-model="card.receipt"
          label="收款凭证"
          prefix="card"
          placeholder="请上传转账记录截图"
          alert="微信、支付宝转账截图必须显示付款时间、金额、付款学员头像及昵称，现金收款需拍照，否则办卡申请将被驳回。"
          propName="receipt"
        />

        <v-input-you-zan-number
          v-model="card.you_zan_number"
          :card-payment-mode-id="card.card_payment_mode_id"
          @actualPaymentChange="actual_payment => card.actual_payment = card.you_zan_payment = actual_payment"
        />

        <el-form-item v-if="card.card_payment_mode_id === cardPaymentModeIds.youZan" label="有赞核销金额">
          <v-input-money
            class="w100"
            v-model="card.you_zan_payment"
            placeholder="请输入购买有赞的核销金额"
            :is-show-suffix="true"
          />
        </el-form-item>
      </template>

      <el-form-item label="付款备注" prop="payment_remark">
        <el-input v-model="card.payment_remark" placeholder="请输入课卡付款备注"/>
      </el-form-item>

      <v-multi-file-upload v-model="card.remark_files" label="备注文件" prefix="card"/>

      <el-form-item label="可用日期">
        <el-checkbox v-model="v.checked" v-for="v in weeks" :key="v.value">{{ v.label }}</el-checkbox>
        <el-alert
          title="勾选后，可预约对应日期的课程，默认全部可约"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="办卡日期" prop="register_time">
        <el-date-picker
          v-model="card.register_time"
          :picker-options="pickerOptionsBetweenSystemStartAndToday"
          align="right"
          type="date"
          placeholder="请选择办卡日期，默认为当前日期"
          class="date-picker"
          value-format="timestamp"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="自动开卡日期" prop="start_time_auto">
        <el-date-picker
          v-model="card.start_time_auto"
          :picker-options="pickerOptionsOfAfterToday"
          align="right"
          type="date"
          placeholder="请选择自动开卡日期，默认不自动开卡"
          class="date-picker"
          value-format="timestamp"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item
        v-show="cardTypeInfo.length && card.card_type !== cardTypes.personal.value"
        label="设为默认支付课卡"
      >
        <el-switch v-model="card.is_default_used" :active-value="1" :inactive-value="0"/>
      </el-form-item>

      <template v-if="cardTicketType.id">
        <el-alert
          title="购买本课卡附赠一张课次券"
          type="success"
          show-icon
          :closable="false"
        />

        <div class="form-divider-title">赠券信息</div>

        <el-form-item label="课次券名称">
          <span class="success-color">{{ cardTicketType.card_ticket_type_name }}</span>
        </el-form-item>
        <el-form-item label="有效次数">
          <span class="success-color">{{ cardTicketType.expire_number | toYuan }}</span> 次
        </el-form-item>
        <el-form-item label="有效天数">
          <span class="success-color">{{ cardTicketType.expire_days | toYuan }}</span> 天
        </el-form-item>
      </template>

      <el-form-item v-if="isDiff" label="申请原因" prop="apply_remark">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入 2 个字符以上的申请原因"
          v-model="card.apply_remark"
          maxlength="250"
          show-word-limit
        />
        <el-alert
          :title="`当前输入的${diffTip}不符，请注意是否填写正确`"
          type="warning"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">
          重新提交审核
        </el-button>
        <el-button @click="RouteConfig.cardAddApplyList.back">取消</el-button>
      </el-form-item>

    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import cardPaymentModeIds from '@/enums/cardPaymentModeIds';
import handleCardTypeChange from '@/utils/handleCardTypeChange';
import weeks from '@/enums/weeks';
import { mapGetters } from 'vuex';
import { cardTypes } from '@/enums/cardTypes';
import { pickerOptionsBetweenSystemStartAndToday, pickerOptionsOfAfterToday } from '@/utils/formats';
import { getDetailByCardChargeTypeId } from '@/api/card-ticket-type';
import { show, restore } from '@/api/card-add-apply';
import { checkIsNew } from '@/api/student';
import { plus, minus, toCent, toYuan, toSecond, toMillisecond } from '@/filters';

const defaultCardTicketType = {
  id: 0,
  update_time: 0,
  card_ticket_type_name: '',
  expire_days: 0,
  expire_number: 0,
};

export default {
  name: RouteConfig.cardAddApplyEdit.name,
  data: () => ({
    RouteConfig,
    cardPaymentModeIds,
    cardTypes,
    pickerOptionsBetweenSystemStartAndToday,
    pickerOptionsOfAfterToday,
    weeks: JSON.parse(JSON.stringify(weeks)),
    isSaving: false,
    cardNumber: '',
    integral: 0,
    isNew: false,
    isUsedCardInvalid: false,
    card: {
      student_id: '',
      store_ids: [],
      card_number: '',
      is_generic: 0,
      card_type_id: 0,
      card_type_name: '',
      card_name: '',
      card_charge_type_id: '',
      is_number_limit: 0,
      expire_number: '',
      expire_number_default: '',
      expire_days: '',
      expire_days_default: '',
      store_limit_expire_days: '',
      card_payment_mode_id: '',
      you_zan_number: '',
      price: '',
      actual_payment: '',
      you_zan_payment: '',
      payment_remark: '',
      receipt: '',
      remark_files: [],
      integral: '',
      register_time: '',
      start_time_auto: '',
      is_default_used: 1,
      is_disable_column: 0,
      disabled_weeks: [],
      apply_remark: '',
      update_time: 0,
      voucher_ids: [],
      voucher_amount_in_cents: 0,
    },
    cardTicketType: JSON.parse(JSON.stringify(defaultCardTicketType)),
    cardTypeInfo: [],
    studentList: [{
      id: 0,
      student_name: '',
      nickname: '',
      phone: '',
      card_number: '',
    }],
    rules: {
      student_id: [{ required: true, message: '请选择所属学员', trigger: 'change' }],
      card_payment_mode_id: [{ required: true, message: '请选择课卡付款方式', trigger: 'change' }],
      card_charge_type_id: [{ required: true, message: '请选择课卡类型', trigger: 'change' }],
      card_number: [{ required: true, message: '请输入会员卡号', trigger: 'change' }],
      you_zan_number: [{ required: true, message: '请输入有赞券码', trigger: 'change' }],
      actual_payment: [{ required: true, message: '请输入实付金额', trigger: 'change' }],
      receipt: [{ required: true, message: '请上传付款凭证图片', trigger: 'change' }],
      apply_remark: [{ required: true, message: '请输入申请原因', trigger: 'change' }],
    },
  }),
  watch: {
    'card.integral'(integral) {
      this.computeActualPayment(integral);
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isGenericStore',
      'userStoreId',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
    diffTip() {
      let tips = [];
      if (this.isPriceDiff) tips.push('实际付款与课卡原价');
      if (this.isDaysDiff) tips.push('有效天数与课卡原有效天数');
      if (this.isNumberDiff) tips.push('有效次数与课卡原有效次数');
      return tips.join('、');
    },
    isPriceDiff() {
      if (!this.card.price || this.card.price <= 0) return false;
      return this.card.price !== plus(this.card.actual_payment, this.card.integral, this.card.voucher_amount_in_cents);
    },
    priceAlertMessage() {
      const receivable = minus(this.card.price, this.card.integral, this.card.voucher_amount_in_cents);
      const parts = [];
      if (this.card.integral > 0 || this.card.voucher_amount_in_cents > 0) {
        parts.push(`原价 ${this.card.price} 元`);
        if (this.card.integral > 0) parts.push(`积分抵扣 ${this.card.integral} 元`);
        if (this.card.voucher_amount_in_cents > 0) {
          const voucherCount = (this.card.voucher_ids || []).length;
          parts.push(`代金券抵扣 ${this.card.voucher_amount_in_cents} 元${voucherCount > 1 ? `（${voucherCount} 张）` : ''}`);
        }
      }
      parts.push(`应收 ${receivable} 元`);
      parts.push(`实收 ${this.card.actual_payment} 元`);
      return parts.join('，');
    },
    isDaysDiff() {
      return this.card.expire_days !== this.card.expire_days_default;
    },
    isNumberDiff() {
      return this.card.expire_number !== this.card.expire_number_default;
    },
    isDiff() {
      return !this.isAdministrator
        && (this.isPriceDiff || this.isDaysDiff || this.isNumberDiff)
        && this.card.card_payment_mode_id !== cardPaymentModeIds.youZan;
    },
  },
  mounted() {
    this.card.store_ids = this.isGenericStore ? [] : [this.userStoreId];// 设置一个值 自动获取课卡类型
  },
  beforeMount() {
    this.show();
  },
  methods: {
    toYuan,
    computeActualPayment(integral = this.card.integral) {
      const actualPayment = minus(this.card.price, integral, this.card.voucher_amount_in_cents);
      this.card.actual_payment = Math.max(0, actualPayment);
    },
    async handleStudentChange(student) {
      const { isError, data } = await checkIsNew(student.id);
      Object.assign(this, {
        cardNumber: student.card_number,
        integral: student.integral,
        isNew: !isError && data ? !!data.is_new : false,
      });
      this.card.is_default_used = student.is_used_card_invalid ? 1 : 0;
      // 切换学员时重置代金券，列表由 VSelectVoucher 内部根据学员重新拉取
      this.card.voucher_ids = [];
      this.card.voucher_amount_in_cents = 0;
      this.computeActualPayment();
    },
    handleVoucherChange(vouchers) {
      const list = Array.isArray(vouchers) ? vouchers : (vouchers ? [vouchers] : []);
      this.card.voucher_ids = list.map(voucher => voucher.id);
      // 合计抵扣金额由各券面额求和；前端仅用于展示与重算实收，后端会二次校验
      this.card.voucher_amount_in_cents = list.reduce(
        (total, voucher) => plus(total, toYuan(voucher.amount_in_cents)),
        0,
      );
      this.computeActualPayment();
    },
    handleCardTypeChange(cardTypeInfo) {
      handleCardTypeChange(cardTypeInfo, this.card);
      this.getDetailsByCardChargeTypeId();
      this.computeActualPayment(this.card.integral);
    },
    async show() {
      this.isLoadFailed = false;
      const { isError, data } = await show(this.id);
      if (isError || !data) return this.isLoadFailed = true;

      data.register_time = toMillisecond(data.register_time) || '';
      data.start_time_auto = toMillisecond(data.start_time_auto) || '';
      data.expire_time = toMillisecond(data.expire_time) || '';
      data.store_limit_expire_time = toMillisecond(data.store_limit_expire_time) || '';
      data.expire_number = toYuan(data.expire_number);
      data.expire_number_default = toYuan(data.expire_number_default);
      data.price = toYuan(data.price);
      data.actual_payment = toYuan(data.actual_payment);
      data.you_zan_payment = toYuan(data.you_zan_payment);
      data.integral = toYuan(data.integral);
      data.voucher_amount_in_cents = toYuan(data.voucher_amount_in_cents);

      const { card } = this;
      let updateData = {};
      let enabledWeeks = [];

      Object.keys(data).forEach(key => {
        if (key in card) updateData[key] = data[key];
      });

      if (Array.isArray(data.disabled_weeks) && data.disabled_weeks.length) {
        const { weeks } = this;
        for (let i = 0; i < weeks.length; i++) {
          if (!data.disabled_weeks.includes(weeks[i].value)) enabledWeeks.push(weeks[i]);
        }
      } else {
        enabledWeeks = weeks;
      }

      updateData.enabled_weeks = enabledWeeks;
      Object.assign(card, updateData);
      // 回填已选代金券（多张）
      card.voucher_ids = (data.vouchers || []).map(voucher => voucher.voucher_id);
      this.studentList = [{
        id: data.student_id,
        student_name: data.student_name,
        nickname: data.nickname,
        selfie: data.selfie,
        phone: data.phone,
        card_number: data.card_number,
        integral: data.student_integral,
      }];
      this.cardNumber = data.card_number;
      this.integral = data.student_integral;
      this.isNew = !!data.is_new;
      this.cardTypeInfo = data.card_type_info || [];
      this.getDetailsByCardChargeTypeId();
    },
    async getDetailsByCardChargeTypeId() {
      if (!this.card.card_charge_type_id) return;

      const { isError, data } = await getDetailByCardChargeTypeId(this.card.card_charge_type_id);
      if (isError || !data || !data.id) return this.cardTicketType = JSON.parse(JSON.stringify(defaultCardTicketType));

      const { cardTicketType } = this;
      const updateData = {};
      Object.keys(data).forEach(key => {
        if (key in cardTicketType) updateData[key] = data[key];
      });
      Object.assign(cardTicketType, updateData);
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const card = { ...this.card };
        const { weeks } = this;

        card.is_diff = this.isDiff ? 1 : 0;
        card.register_time = toSecond(card.register_time);
        card.start_time_auto = toSecond(card.start_time_auto);
        card.expire_number = toCent(card.expire_number);
        card.expire_number_default = toCent(card.expire_number_default);
        card.actual_payment = toCent(card.actual_payment);
        card.you_zan_payment = toCent(card.you_zan_payment);
        card.price = toCent(card.price);
        card.integral = toCent(card.integral);
        card.voucher_amount_in_cents = toCent(card.voucher_amount_in_cents);
        card.disabled_weeks = [];
        card.card_ticket_type_update_time = this.cardTicketType.update_time;

        for (let i = 0; i < weeks.length; i++) {
          if (!weeks[i].checked) card.disabled_weeks.push(weeks[i].value);
        }

        const { isError } = await restore(this.id, card);
        this.isSaving = false;
        if (!isError) RouteConfig.cardAddApplyList.push();
      });
    },
  },
};
</script>

<style scoped>
  .integral-box {
    padding-left: 10px;
    font-size: 16px;
  }

  .integral {
    font-size: 18px;
  }

  .voucher-summary {
    margin-top: 4px;
    font-size: 12px;
    line-height: 20px;
  }
</style>
